import {
  BMComponentsType,
  BMDropdown,
  BMInputField,
  useBMTheme,
} from "@traveloka/district-bloom";
import { DropdownItemProps } from "@traveloka/district-bloom/js/components/Inputfield/component/DropdownItem";
import IcSystemChevronDown from "@traveloka/icon-kit-web/react/IcSystemChevronDown";
import { useState } from "react";
import { DimensionValue, Pressable, StyleSheet } from "react-native";
import { appendTestId } from "../../utils";
import BMView from "../View/BMView";

type Props = {
  value: string;
  items: Omit<
    DropdownItemProps,
    "active" | "isFirst" | "isLast" | "onItemSelect"
  >[];
  onItemSelect: (item: DropdownItemProps) => void;
  width?: DimensionValue;
  placeholder?: string;
  label?: string;
  error?: string | boolean | undefined;
  testID?: string;
};

export default function BMDropdownInput(props: Props) {
  const {
    width,
    items,
    placeholder,
    value = "",
    onItemSelect,
    label = "",
    error,
    testID,
  } = props;
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  return (
    <BMView
      style={{
        width: width,
      }}
    >
      <BMInputField
        placeholder={placeholder}
        buttonInsetType="BUTTON_ICON"
        variant="DROPDOWN"
        onDropdownToggle={() => setIsDropdownVisible(true)}
        buttonInsetProps={{
          Icon: IcSystemChevronDown,
          onPress: () => {},
          iconStyle: styles.dropdownIcon,
        }}
        label={label}
        value={value}
        error={error}
      />
      {isDropdownVisible && (
        <Pressable
          onPress={() => {
            setIsDropdownVisible(!isDropdownVisible);
          }}
          style={styles.dropdownPressable}
        >
          <BMView style={styles.dropdownContainer}>
            <BMDropdown
              items={items}
              onItemSelect={(item) => {
                onItemSelect?.(item);
                setIsDropdownVisible(false);
              }}
              itemTestId={appendTestId(testID, "item")}
            />
          </BMView>
        </Pressable>
      )}
    </BMView>
  );
}

const createStyles = (BMComponents: BMComponentsType) =>
  StyleSheet.create({
    dropdownPressable: {
      position: "absolute",
      zIndex: 998,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: "100%",
    },
    dropdownContainer: {
      position: "absolute",
      zIndex: 999,
      left: 0,
      top: 55,
      width: "100%",
    },
    dropdownIcon: {
      color: BMComponents.BMStyleIconInkSecondary,
      // @ts-expect-error react-native-web only
      accentColor: BMComponents.BMStyleIconInkSecondary,
      fillColor: BMComponents.BMStyleIconInkSecondary,
    },
  });
